import React from 'react'
import './ThankYouForm.css';
import { FaLocationDot } from "react-icons/fa6";


const ThankYouForm = () => {
  return (
    <div className="thank-you">
      <h1>Registration Confirmed!</h1>

      <div className="text1" style={{ textAlign: 'center' }}>
        <label>We look forward to welcoming you at FIA Integra World 2025!</label>
      </div>

      {/* <div className="text2" style={{ color: 'red', textAlign: 'center' }}>
        <label>Asset Management in a Unified Digital Ecosystem conference</label>
      </div>

      <div className="text3">
        <FaLocationDot />
        <label> JW Marriott Grand Hotel Bucharest, salon AB</label>
      </div>

        <div className="text-wrapper">
            <div className="text4"> May this day be with you!</div>
        <div className="text5"> June 19, 2025</div>
        </div> */}
        </div>
  );
};

export default ThankYouForm
